import Vue from 'vue';

export const EventBus = new Vue();

import { getFacetsConfiguration } from '../configs/helper'

export const globalMixin = {
  methods: {
    handleFilters(items) {
      // TODO quiclkly fix for removing hidden filters without removing them in store
      const facets = getFacetsConfiguration();

      // Review this method and simple it -> possible switch case -> each field have his own logic almost
      const filters = {
        all: [],
        any: []
      };
      
      let activeFilter;
      if(items && items.length){
        items.map((filter) => {
         
          // Check if filter exits in current facets
          let allowSearch = true
          if(!facets[filter.field]) {
            allowSearch = false

             Object.values(facets).forEach((values) => {
                if(values && values.elasticSearch) {
                 const exist = values.elasticSearch.find(v => v.facet === filter.field)
                 if(exist) {
                  allowSearch = true
                 }
                }
             })
          }

          if (allowSearch) {
            switch(filter.type){
              case 'value':
                activeFilter = filters.all.find(f => Object.keys(f)[0] === filter.field);

                if(activeFilter){
                  activeFilter[filter.field].push(filter.value) // Add value to array
                } else {
                  if(Array.isArray(filter.value)){
                    filters.all.push({ [filter.field]: filter.value });
                  } else {
                    filters.all.push({ [filter.field]: [filter.value] }); // Initialize the array
                  }
                }

                break;
              case 'range':

                if(filter.value) { // Type range but i only want greater values -> INPUTNUMBER FACET TYPE
                  switch(filter.field){
                    case 'available_stock': // Exceptions
                      filters.all.push({ [filter.field]: { from: filter.value } })
                      break;
                    case 'age_max': // Exceptions   age_min <= input <= age_max
                      filters.all.push({ age_min: {  to: filter.value } })
                      filters.all.push({ age_max: { from: filter.value } })
                      break;
                  }
                } else {
                  if(filters[filter.field]){ // Price filter
                    const fromArray = !filter.from || !filters[filter.field].from ? [null] : [filter.from, filters[filter.field].from].sort((a, b) => a - b);
                    const toArray = !filter.to || !filters[filter.field].to ? [null] : [filter.to, filters[filter.field].to].sort((a, b) => b - a);

                    filters.any.push({ [filter.field]: { from: fromArray[0], to: toArray[0] }})
                  } else {
                    if (['date', 'dateDepart'].includes(filter.field)) {
                      filters.all.push({ [filter.field]: { from: filter.from, to: filter.to }})
                    } else {
                      filters.any.push({ [filter.field]: { from: filter.from, to: filter.to }})
                    }

                  }
                }
                break;
            }
          }
        });
      }

      return filters;
    },
    getItemCode(item, optionalKey) { return item?.id_package || item?.iresaCode || (optionalKey && item?.[optionalKey]) || null; },    
    getItemDate(item, optionalKey) { return item?.date || item?.dateDepart || (optionalKey && item?.[optionalKey]) || null; }
  }
}
